export default [
  {
    path: '/defines/service-types',
    name: 'ServiceTypes',
    component: () => import('@/views/Defines/Service_types/Index.vue'),
    meta: {
      pageTitle: 'Hizmet Şekilleri',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
  {
    path: '/defines/service-types/add',
    name: 'ServiceTypeAdd',
    component: () => import('@/views/Defines/Service_types/Add.vue'),
    meta: {
      pageTitle: 'Hizmet Şekilleri',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/defines/service-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
  {
    path: '/defines/service-types/edit/:id',
    name: 'ServiceTypeEdit',
    component: () => import('@/views/Defines/Service_types/Edit.vue'),
    meta: {
      pageTitle: 'Hizmet Şekilleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/defines/service-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
]
